const SHORTENED_TAB_PATHS = [
  '/meteorology/fields/trackingforecast/',
  '/meteorology/fields/modelperformance/',
  '/meteorology/weather/oscillations/',
  '/relatorios/decomp/',
  '/relatorios/dessem/',
  // Comparador/Matriz de cada informe são top-tabs próprias (não seções do
  // informe) — precisam vir ANTES do prefixo geral do grupo, senão colapsam
  // para a tab errada (ex.: /relatorios/semanal/matriz acenderia "Informe
  // Semanal" em vez de "Matriz").
  '/relatorios/intersemanal/comparador',
  '/relatorios/intersemanal/',
  '/relatorios/semanal/matriz',
  '/relatorios/semanal/comparador',
  '/relatorios/semanal/',
  '/relatorios/mensal/comparador',
  '/relatorios/mensal/',
  '/agro/water-balance-sequential/',
  '/agro/water-balance-culture/',
  '/agro/culture-index/',
  '/agro/trackingforecast/detailedview/',
  '/agro/trackingforecast/',
  '/agro/overview/',
];

export default function shortenedTabPath(path: string) {
  // Caso especial Windx/SM (FE-WINDX-018 + FE-WINDX-047): tela Weol-SM tem
  // sub-tabs (Semanal | Comparativo). Quando estamos em
  // `/windx/automatic/semanal/comparativo`, o top-level TabbedPage do
  // <WindxWrapper> ainda precisa destacar a tab WEOL-SM
  // (path `/windx/automatic/semanal`). Sem isso o destaque sumia.
  // O SemanalLayout usa <Nav> do react-bootstrap (nao TabbedPage) — entao
  // colapsar /windx/automatic/semanal/* em /windx/automatic/semanal so
  // afeta o top-level.
  if (
    path === '/windx/automatic/semanal'
    || path.startsWith('/windx/automatic/semanal/')
  ) {
    return '/windx/automatic/semanal';
  }

  // FE-WINDX-050: WEOL-SH ganhou sub-tabs Semi-horário | Diário. O top-level
  // tab WEOL-SH (path `/windx/automatic`) deve continuar destacado em ambas
  // sub-rotas — colapsamos para o path canonico do tab.
  if (
    path === '/windx/automatic/semi-horario'
    || path === '/windx/automatic/diario'
  ) {
    return '/windx/automatic';
  }

  for (let i = 0; i < SHORTENED_TAB_PATHS.length; i += 1) {
    // `${path}/`: os tabs registram o path canonico COM barra final, mas o
    // router tambem serve a rota sem ela (ex. /agro/overview) — sem esta
    // igualdade o tab ativo nao acende nessa variante.
    if (path.startsWith(SHORTENED_TAB_PATHS[i]) || `${path}/` === SHORTENED_TAB_PATHS[i]) {
      return SHORTENED_TAB_PATHS[i];
    }
  }

  return path;
}
